import React from 'react';
import PropTypes from 'prop-types';
import { Form, Row, Col, } from 'react-bootstrap';
import ObjectUtils from '../../../modules/ObjectUtils';
import ServicesList from './ServiceList';
import ServiceOfferingsDisplay from './ServiceOfferingsDisplay';
import ServiceOfferingService from '../../../service/ServiceOfferingService';
import '../View.css';
import './ServiceManagement.css';

const getLocation = (location) => {
  if (location === 'cts') {
    return 'Client Transform Service';
  } if (location === 'pis') {
    return 'Payable Integration Service';
  }
  if (location === 'ptax') {
    return 'Property Tax Service';
  }
  if (location === 'sdk') {
    return 'SDK';
  }
  if (location === 'water') {
    return 'Water Service';
  }
  if (location === 'citations') {
    return 'Citations Service';
  }
  return '';
};

class UtilitiesManagement extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      search: '',
      serviceOfferings: [ {}, ],
      migratedServiceOfferings: [ 'gr_water', ],
      migratedPTaxServiceOfferings: [ 'shelby_tax', 'beaufort', ],
    };
  }

  async componentDidMount() {
    await this.getAllServiceOfferings();
  }

  async getAllServiceOfferings() {
    const serviceOfferings = (await ServiceOfferingService.getAllServiceOfferings()).data.serviceOfferings
      .map(service => this.formatServiceOffering(service));

    const {
      migratedPTaxServiceOfferings,
      migratedServiceOfferings,
    } = this.state;
    const { navigation: { navItems, }, } = this.props;
    const serviceManagementItems = navItems.find(item => item.name === 'Service Management').items;

    const navigableServiceOfferings = serviceOfferings.filter(offering => {
      const foundItem = !!serviceManagementItems.find((item) => item.key === offering._id);
      return !!foundItem;
    });

    migratedPTaxServiceOfferings.forEach((soid) => {
      const existingServiceOffering = navigableServiceOfferings.find(offering => offering._id === soid);
      if (existingServiceOffering) {
        navigableServiceOfferings.push({
          _id: `${soid}_v1`,
          displayName: `${existingServiceOffering.serviceOfferingName} 1.0`,
          url: existingServiceOffering.url,
          serviceOfferingName: `${existingServiceOffering.serviceOfferingName} 1.0`,
        });
      }
    });
    migratedServiceOfferings.forEach((soid) => {
      const existingServiceOffering = navigableServiceOfferings.find(offering => offering._id === soid);
      if (existingServiceOffering) {
        navigableServiceOfferings.push({
          _id: `${soid}_v2`,
          displayName: `${existingServiceOffering.serviceOfferingName} 2.0`,
          url: existingServiceOffering.url,
          serviceOfferingName: `${existingServiceOffering.serviceOfferingName} 2.0`,
        });
      }
    });
    const serviceOfferingsWithInfo = navigableServiceOfferings.map((serviceOffering) => {
      const serviceOfferingWithInfo = serviceOffering;
      serviceOfferingWithInfo.info = ServicesList[serviceOffering._id];
      if (!serviceOfferingWithInfo.info) {
        serviceOfferingWithInfo.info = {
          id: serviceOffering._id,
          location: getLocation(serviceOffering.location),
          description: serviceOffering.description || getLocation(serviceOffering.location),
          tooltipDescription: serviceOffering.serviceOfferingName,
        };
      }

      return serviceOfferingWithInfo;
    });
    navigableServiceOfferings.sort(ObjectUtils.dynamicSort('_id'));

    this.setState({
      serviceOfferings: serviceOfferingsWithInfo,
      loaded: true,
    });
  }

  formatServiceOffering(service) {
    return {
      ...service.attributes,
      location: service.location,
      serviceOfferingName: service.attributes.displayName,
      _id: service.id,
      url: service.url,
    };
  }

  handleChange(event) {
    this.setState({ search: event.target.value, });
  }

  handleKeyPress(event) {
    if (event.which === 13) {
      event.preventDefault();
    }
  }

  content() {
    const { search, serviceOfferings, } = this.state;
    const { sendNavigationRequest, } = this.props;

    return (
      <div className="service-offering-wrapper">
        <ServiceOfferingsDisplay
          serviceOfferings={serviceOfferings}
          search={search}
          sendNavigationRequest={sendNavigationRequest}
        />
      </div>
    );
  }

  render() {
    const { loaded, } = this.state;

    return (
      <div className="content">
        <h2 className="heading">Service Management</h2>
        <Form>
          <Row className="justify-content-center">
            <Col lg={5}>
              <Form.Group className="mb-2" controlId="formSearch">
                <Form.Control
                  type="input"
                  placeholder="Search for a service offering"
                  onChange={event => this.handleChange(event)}
                  onKeyPress={this.handleKeyPress}
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
        {loaded ? this.content() : null}
      </div>
    );
  }
}

UtilitiesManagement.propTypes = {
  sendNavigationRequest: PropTypes.instanceOf(Function).isRequired,
  navigation: PropTypes.instanceOf({
    navItems: PropTypes.instanceOf(Array),
  }).isRequired,
};

export default UtilitiesManagement;
